export const BUNDLES_REQUEST = 'bundlesRequest';
export const BUNDLES_FAILURE = 'bundlesFailure';
export const BUNDLES_SUCCESS = 'bundlesSuccess';

export const STRIPE_REQUEST = 'stripeRequest';
export const STRIPE_FAILURE = 'stripeFailure';
export const STRIPE_SUCCESS = 'stripeSuccess';

export const PAYMENT_REQUEST = 'paymentRequest';
export const PAYMENT_FAILURE = 'paymentFailure';
export const PAYMENT_SUCCESS = 'paymentSuccess';

export const PAYMENT_INTENT_REQUEST = 'paymentIntentRequest';
export const PAYMENT_INTENT_FAILURE = 'paymentIntentFailure';
export const PAYMENT_INTENT_SUCCESS = 'paymentIntentSuccess';

export const COUPON_PAYMENT_INTENT_REQUEST = 'couponPaymentIntentRequest';
export const COUPON_PAYMENT_INTENT_FAILURE = 'couponPaymentIntentFailure';
export const COUPON_PAYMENT_INTENT_SUCCESS = 'couponPaymentIntentSuccess';
export const COUPON_PAYMENT_SUCCESS = 'couponPaymentSuccess';

export const PREMIUM_PAYMENT_INTENT_REQUEST = 'premiumPaymentIntentRequest';
export const PREMIUM_PAYMENT_INTENT_FAILURE = 'premiumPaymentIntentFailure';
export const PREMIUM_PAYMENT_INTENT_SUCCESS = 'premiumPaymentIntentSuccess';
export const PREMIUM_PAYMENT_SUCCESS = 'premiumPaymentSuccess';

export const STRIPE_KEY =
  process.env.REACT_APP_ENV === 'dev'
    ? 'pk_test_EuCBrpvsYsDdF3CuTsjhdYpi'
    : 'pk_live_ak6LjVS5wESjx3AdFjsTu9UV';
export const PAYPAL_KEY =
  process.env.REACT_APP_ENV === 'dev'
    ? 'AaeRs8mbEIShHMYFGR9kGYTMqJmlLsa1ua-Le4HdVNUKgv7S0Z4n_SwfWH43f64L3moNr0t0w7arcxRy'
    : 'AXml4R-UxtbQ_WDJNXAgbevl-rFf_ES1u9R3zpe_KyMqQVJR4g2i-Y176TAh-97N6cC79Yty_VwRMOZr';
